import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Search, Globe, BookOpen, Compass, Coins, MapPin, Heart, ChevronRight, Sparkles } from 'lucide-react';
import { useState, useEffect } from 'react';
import OceanBackground from '@/components/background/OceanBackground';
const banners = [
  { title: '大理慢生活', desc: '洱海边的七天', img: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=1400&q=65' },
  { title: '西藏朝圣之路', desc: '雪山·寺庙·星空', img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1400&q=65' },
  { title: '成都美食图鉴', desc: '辣与不辣都精彩', img: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=1400&q=65' },
];

const features = [
  { label: '游记攻略', to: '/travelogues', icon: BookOpen },
  { label: 'AI规划', to: '/planner', icon: Compass },
  { label: '目的地', to: '/destinations', icon: MapPin },
  { label: '积分商城', to: '/points', icon: Coins },
];

const articles = [
  { title: '如何在旅行中拍出大片感', author: '摄影师李', likes: 342, img: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=500&q=60' },
  { title: '云南十日深度游攻略', author: '背包客阿杰', likes: 856, img: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=500&q=60' },
  { title: '日本关西赏枫指南', author: '樱花妹', likes: 620, img: 'https://images.unsplash.com/photo-1492571350019-22de08371fd3?w=500&q=60' },
];

const Discover = () => {
  const navigate = useNavigate();
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrentBanner((p) => (p + 1) % banners.length), 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, rgba(16,26,48,0.82) 0%, rgba(22,37,68,0.78) 50%, rgba(16,26,48,0.82) 100%)' }}>
      <Navbar />
      <OceanBackground />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20 relative z-10">
        {/* Search */}
        <div className="relative mb-8" style={{ animation: 'rise .75s ease-out both' }}>
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 cd" />
          <input
            className="ocean-input pl-12 h-14 text-base"
            placeholder="搜索你想去的地方、游记、攻略..."
            onKeyDown={(e) => e.key === 'Enter' && navigate('/search')}
          />
        </div>

        {/* Banner */}
        <div className="relative h-[260px] rounded-3xl overflow-hidden mb-12" style={{ animation: 'rise .75s ease-out .05s both' }}>
          <img src={banners[currentBanner].img} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(100deg, rgba(16,26,48,0.95) 0%, transparent 70%)' }} />
          <div className="absolute bottom-6 left-6">
            <div className="ls ls-tl mb-3"><Sparkles className="w-3 h-3" /> {banners[currentBanner].title}</div>
            <h2 className="text-2xl font-bold text-white mb-1">{banners[currentBanner].title}</h2>
            <p className="cm text-sm">{banners[currentBanner].desc}</p>
          </div>
          <div className="absolute bottom-4 right-6 flex gap-2">
            {banners.map((_, i) => (
              <button key={i} onClick={() => setCurrentBanner(i)} className="w-2 h-2 rounded-full transition" style={{ background: i === currentBanner ? '#fff' : 'rgba(255,255,255,0.3)' }} />
            ))}
          </div>
        </div>

        {/* features */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {features.map((f) => (
            <button key={f.label} onClick={() => navigate(f.to)} className="frost p-5 flex items-center gap-3 hover:!bg-[rgba(30,56,96,0.5)]" style={{ animation: 'rise .75s ease-out 0.1s both' }}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg, var(--glow), var(--mid))', boxShadow: '0 4px 14px rgba(61,130,176,0.3)' }}>
                <f.icon className="w-5 h-5 text-white" />
              </div>
              <span className="font-medium text-sm cb">{f.label}</span>
            </button>
          ))}
        </div>

        {/* Hot articles */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold cb">精选游记</h2>
          <button onClick={() => navigate('/travelogues')} className="text-sm cg flex items-center hover:underline">全部 <ChevronRight className="w-4 h-4" /></button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {articles.map((a, i) => (
            <button key={i} onClick={() => navigate('/travelogues')} className="frost overflow-hidden cursor-pointer text-left" style={{ animation: `rise .75s ease-out ${0.15 + i * 0.07}s both` }}>
              <div className="aspect-[16/10] relative">
                <img src={a.img} alt="" className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 30%, rgba(16,26,48,0.9))' }} />
              </div>
              <div className="p-4">
                <p className="font-medium cb line-clamp-1 mb-2">{a.title}</p>
                <div className="flex items-center justify-between text-[12px] cd">
                  <span>{a.author}</span>
                  <span className="flex items-center gap-1"><Heart className="w-3 h-3" /> {a.likes}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Discover;
